import { render, staticRenderFns } from "./CommonCouponModule.vue?vue&type=template&id=9d4bcd28&"
import script from "./CommonCouponModule.vue?vue&type=script&lang=js&"
export * from "./CommonCouponModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports